
export const outlook_info = 'Microsoft Outlook is our organization\'s primary email and calendar platform. It is included in the Microsoft 365 suite.'

export const outlook_md = `
# Microsoft Outlook  
*Last updated on July 15, 2025*

## Overview

Microsoft Outlook is our organization's primary email and calendar platform. It is included in the Microsoft 365 suite.
Outlook allows you to send and receive email, schedule meetings, manage contacts, and access your [Microsoft 365 Groups](https://it.bockwaterheaters.com/#/services/groups).

**Important Note**: as many of you may have noticed, Microsoft has released an optional 'New Outlook' app. At this time, we recommend continuing to use the Classic Outlook app. 
The New Outlook app is still missing many of the features we use on a daily basis here. 
You may choose to use the New Outlook app, but please be warned that our ability to solve issues relating to the New Outlook app will be limited.

## Benefits
- **All-in-One**: Combines email, calendar, contacts, and tasks in one place.
- **Cross-Platform**: Access from Windows, macOS, web, iOS, and Android.
- **Collaboration**: Shared calendars and meeting scheduling with ease.
- **Security**: Built-in spam filtering, encryption, and phishing protection.
- **Integration**: Works seamlessly with Teams, Word, Excel, and OneDrive.

## Requirements
- A user account with us
- A valid Microsoft 365 subscription
- Internet access

## Getting Started
- Outlook is included as part of the [Microsoft 365](https://it.bockwaterheaters.com/#/services/m365) suite.

For web access, go to [https://outlook.office.com](https://outlook.office.com), sign in, and you'll be taken directly to your inbox.

## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)


`